/**
 * OMG Shutter Text Animation
 * Animated letter-by-letter reveal with colored slice sweeps.
 * Targets elements with class .omg-shutter-text and data-text attribute.
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var el = document.querySelector('.omg-shutter-text');
    if (!el) return;

    var text = el.getAttribute('data-text') || '';
    var fallback = document.querySelector('.omg-shutter-text-fallback');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.style.display = 'none';
      if (fallback) fallback.style.display = '';
      return;
    }

    function buildChars() {
      var html = '';
      for (var i = 0; i < text.length; i++) {
        var ch = text[i] === ' ' ? '&nbsp;' : text[i];
        html +=
          '<div class="omg-shutter-char" style="--i:' + i + '">' +
            '<span class="omg-shutter-char__main">' + ch + '</span>' +
            '<span class="omg-shutter-char__slice omg-shutter-char__slice--top">' + ch + '</span>' +
            '<span class="omg-shutter-char__slice omg-shutter-char__slice--mid">' + ch + '</span>' +
            '<span class="omg-shutter-char__slice omg-shutter-char__slice--bot">' + ch + '</span>' +
          '</div>';
      }
      return html;
    }

    // Last char reveal ends at: (len-1)*0.12s + 0.8s delay + 2s duration
    var effectDone = ((text.length - 1) * 0.12 + 0.8 + 2) * 1000;

    function play() {
      el.classList.remove('omg-shutter-text--fade-out');
      el.innerHTML = buildChars();

      // After effect finishes + 3s pause, fade out
      setTimeout(function () {
        el.classList.add('omg-shutter-text--fade-out');

        // After fade (1.5s) + 3s pause, replay
        setTimeout(play, 1500 + 3000);
      }, effectDone + 3000);
    }

    play();
    if (fallback) fallback.style.display = 'none';
  });
})();
